<template>
    <section
        :class="{
            'review-section': true,
            'review-section--border-bottom': borderBottom,
        }"
        :aria-labelledby="cardId"
    >
        <header
            class="review-section__header spacing-b-2"
        >
            <h2
                class="review-section__title"
                :id="cardId"
            >
                {{ title }}
            </h2>
	
            <button
                v-if="$listeners.edit"
                @click="$emit('edit')"
                class="review-section__btn"
                :aria-label="$ml.with(0, title).get('ariaLabelEditSection')"
            >
                {{ $ml.get(btnText) }}
            </button>
        </header>

        <div class="review-section__content">
            <slot />
        </div>
    </section>
</template>

<script>
	export default {
		props: {
			title: {
				type: String,
				required: true,
			},
			borderBottom: {
				type: Boolean,
				default: true,
			},
			btnText: {
				type: String,
				default: 'edit',
			},
		},

		computed: {
			cardId() {
				return `section-${this._uid}`;
			},
		},

		methods: {},
	};
</script>

<style scoped lang='scss'>
	.review-section {
		&--border-bottom {
			padding-bottom: 24px;
			border-bottom: 2px solid #DBE0E5;
		}

		&__header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 9.5px 0;
			
			> * {
				font-size: 1rem;
				line-height: 1rem;
				font-weight: 600;
			}
		}

		&__title {
			color: #2F363E;
			margin: 0;
		}

		&__btn {
			background-color: transparent;
			color: #0774E7;
			cursor: pointer;
			text-decoration: none;
			padding: 0;
			border: none;

			&:hover {
				text-decoration: underline;
			}
		}

		&__content {
			> span {
				display: block;
				font-size: 16px;
				color: #5C6A7B;
			}

			.inputs-container {
				display: flex;
				flex-direction: column;

				@media screen and (min-width: 1025px) {
					flex-direction: row;
					gap: 20px;
				}

				> * {
					@media screen and (min-width: 1025px) {
						flex: 1;
					}
				}
			}
		}

	}
</style>
